"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListServer = exports.ImportStatus = void 0;
const axios_1 = __importDefault(require("axios"));
const url_search_params_1 = __importDefault(require("@ungap/url-search-params"));
const APIErrors_1 = require("./resources/APIErrors");
const APITasks_1 = require("./resources/APITasks");
const APIAbortController_1 = require("./APIAbortController");
const ClientSummaryInfo_1 = require("./ClientSummaryInfo");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const TaskProgress_1 = require("./TaskProgress");
const index_1 = require("./index");
const LogLevel_1 = require("./LogLevel");
const URLSearchParams = url_search_params_1.default;
var ImportStatus;
(function (ImportStatus) {
    ImportStatus[ImportStatus["none"] = 0] = "none";
    ImportStatus[ImportStatus["imported"] = 1] = "imported";
    ImportStatus[ImportStatus["queued"] = 2] = "queued";
    ImportStatus[ImportStatus["error"] = 3] = "error";
    ImportStatus[ImportStatus["reimport"] = 4] = "reimport";
    ImportStatus[ImportStatus["flat"] = 5] = "flat";
})(ImportStatus = exports.ImportStatus || (exports.ImportStatus = {}));
const EntryNumberDefaults = {
    height: 0,
    id: 0,
    importStatus: 0,
    lastModified: 0,
    size: 0,
    width: 0,
};
class ListServer {
    constructor(classInit, taskController) {
        this.classInit = classInit;
        this.taskController = taskController;
        this.getSubdirectories = async (path, baseDir, subDirsToRead, ld, options, progressSize, progressStart, depth, loopData) => {
            const collectEntries = !options.dropEntries;
            const prgSize = (subDirsToRead.length === 0) ? 0 : progressSize / subDirsToRead.length;
            let src = subDirsToRead.pop();
            let i = 0;
            while (src) {
                APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                const subDirPath = path + src;
                const prgStart = progressStart + prgSize * i;
                this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.readSubDir, [subDirPath, depth], prgStart, 100);
                await this.doRead(subDirPath, baseDir, options, depth + 1, loopData, prgStart, prgSize)
                    .then((ldSub) => {
                    ld.summary.entryCount += ldSub.summary.entryCount;
                    ld.summary.directoryCount += ldSub.summary.directoryCount;
                    ld.summary.imageCount += ldSub.summary.imageCount;
                    ld.summary.completeCount += ldSub.summary.completeCount;
                    if (collectEntries) {
                        ld.entries = ld.entries.concat(ldSub.entries);
                    }
                    ListServer.addClientSummaryInfo(ld.summary.clientInfo, ldSub.summary.clientInfo);
                })
                    .catch((err) => {
                    if (this.com.isAbortError(err) || (!options.continueOnError)) {
                        if (axios_1.default.isCancel(err)) {
                            return err;
                        }
                        else
                            throw err;
                    }
                    if (options._fnQueueError !== undefined) {
                        options._fnQueueError.fn.call(options._fnQueueError.ctx, err);
                    }
                    this.taskController.error(err);
                });
                i++;
                src = subDirsToRead.pop();
            }
        };
        this.client = classInit.client;
        this.com = classInit.com;
        this.baseURL = this.client.getServerBaseQuery();
    }
    static GET_EMPTY_LIST_DATA(path = "", connectorType = "none") {
        return {
            entries: [],
            summary: {
                _baseDir: "",
                clientInfo: new ClientSummaryInfo_1.ClientSummaryInfo(),
                completeCount: 0,
                connectorType,
                dir: path,
                directoryCount: 0,
                entryCount: 0,
                imageCount: 0,
                lastModified: 0,
            }
        };
    }
    static CLONE_LIST_ENTRY(entry) {
        return Object.assign({}, entry);
    }
    static isValidConnectorType(loopData, type) {
        let ret;
        if (!loopData.checkConnectorType) {
            ret = true;
        }
        else {
            if (type === undefined) {
                type = "undefined";
            }
            ret = (loopData.validConnectorTypes[type]);
        }
        return ret;
    }
    static addClientSummaryInfo(infoMain, infoAdd) {
        infoMain.directoryCount += infoAdd.directoryCount;
        infoMain.fileCount += infoAdd.fileCount;
        infoMain.entryCount += infoAdd.entryCount;
        for (const state in infoMain.importStates) {
            infoMain.importStates[state] += infoAdd.importStates[state];
        }
        infoMain.totalSize += infoAdd.totalSize;
    }
    static updateClientSummary(ld, options) {
        ld.summary.clientInfo.directoryCount = ld.summary.directoryCount;
        ld.summary.clientInfo.fileCount = ld.summary.imageCount;
        ld.summary.clientInfo.entryCount = ld.summary.entryCount;
        let sz = 0;
        let entries = 0;
        for (const entry of ld.entries) {
            entries++;
            if (entries % 50 === 0) {
                APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            }
            if (entry.type === "file") {
                if (!isNaN(entry.size)) {
                    sz += entry.size;
                }
                if (entry.importStatus !== undefined) {
                    ld.summary.clientInfo.importStates[entry.importStatus]++;
                }
            }
        }
        ld.summary.clientInfo.totalSize += sz;
        if (options.generateDirProgress && options._taskProgress && options._taskProgress.clientSummary) {
            ListServer.addClientSummaryInfo(options._taskProgress.clientSummary, ld.summary.clientInfo);
        }
    }
    read(path, options = {}) {
        path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(path);
        if (!options.fnProgress && this.client.getProgressFunction()) {
            options.fnProgress = this.client.getProgressFunction();
        }
        if (options.fnProgress !== undefined || options._fnQueueProgress !== undefined) {
            options._taskProgress = new TaskProgress_1.TaskProgress();
            options._taskProgress.currentTask = this.com.taskSupplier.get(APITasks_1.APITasks.readListServer, [path]);
            options._taskProgress.clientSummary = new ClientSummaryInfo_1.ClientSummaryInfo();
        }
        const loopData = {
            blackList: {},
            checkConnectorType: true,
            maxDepth: 0,
            note: "",
            validConnectorTypes: {},
            canceled: false
        };
        if (options.validConnectorTypes === undefined) {
            options.validConnectorTypes = index_1.FSIServerClient.connectorTypesDefault;
        }
        if (typeof (options.validConnectorTypes) === "string") {
            if (options.validConnectorTypes === "*") {
                loopData.checkConnectorType = false;
            }
            else {
                loopData.validConnectorTypes[options.validConnectorTypes] = true;
            }
        }
        else {
            const connectorTypes = {};
            for (const cType of options.validConnectorTypes) {
                connectorTypes[cType] = true;
            }
            loopData.validConnectorTypes = connectorTypes;
        }
        if (options.blackList) {
            let on;
            const blackListNormalized = {};
            for (const blItem of options.blackList) {
                on = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(blItem);
                blackListNormalized[on] = true;
            }
            loopData.blackList = blackListNormalized;
        }
        if (path === "/")
            this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.readListConnectors, [], 0, 100);
        else
            this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.readListServer, [path], 0, 100);
        const baseDir = (options.baseDir) ? options.baseDir : path;
        return this.doRead(path, baseDir, options, 0, loopData, 0, 100);
    }
    async doRead(path, baseDir, options, depth = 0, loopData, progressStart, progressSize) {
        path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(path);
        const isRootDir = (depth === 0 && path === "/");
        loopData.maxDepth = Math.max(loopData.maxDepth, depth);
        if (options.blackList !== undefined && loopData.blackList[path]) {
            this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.skipDirBlackList, [path]);
            return new Promise((resolve) => {
                return resolve(ListServer.GET_EMPTY_LIST_DATA(path));
            });
        }
        const template = options.template || "interface_thumbview_default.json";
        const q = new URLSearchParams("type=list");
        q.set("tpl", template);
        if (options.limit) {
            q.set("limit", options.limit);
        }
        if (options.sort) {
            q.set("sort", options.sort);
        }
        if (options.sortOrder) {
            q.set("sortorder", options.sortOrder);
        }
        if (options.headers) {
            q.set("headers", options.headers);
        }
        const maxRecursiveDepth = (!options.maxRecursiveDepth ||
            isNaN(options.maxRecursiveDepth) ||
            options.maxRecursiveDepth < 0) ? this.client.getMaxRecursiveDepth() : options.maxRecursiveDepth;
        let typeFilter = options.typeFilter || "all";
        if (typeFilter !== "all") {
            if (typeFilter !== "directory") {
                typeFilter = "file";
            }
            q.set("typefilter", typeFilter);
        }
        if (options.items) {
            q.set("items", options.items.join(","));
        }
        q.set("source", path);
        const subDirsToRead = [];
        return this.com.getJSON(this.client.getServerBaseQueryPath() + q.toString(), { def: APIErrors_1.APIErrors.list, content: [path] }, undefined, options)
            .then(response => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            const body = response;
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            if (body.summary === undefined || body.entries === undefined) {
                throw this.com.err.get(APIErrors_1.APIErrors.list, [path], APIErrors_1.APIErrors.invalidServerReply);
            }
            const ld = body;
            ld.summary._baseDir = baseDir;
            ld.summary.clientInfo = new ClientSummaryInfo_1.ClientSummaryInfo();
            ld.entries.pop();
            this.initListData(ld, options);
            if (ld.summary.connectorType === undefined) {
                ld.summary.connectorType = "undefined";
            }
            if (depth === 0 && !isRootDir) {
                if (!options.readInternalConnectors && path.indexOf("_") === 0) {
                    this.callProgress(LogLevel_1.LogLevel.debug, options, APITasks_1.APITasks.skipInternalConnector, [path]);
                    return ListServer.GET_EMPTY_LIST_DATA(ld.summary.connectorType, ld.summary.dir);
                }
                else if (!ListServer.isValidConnectorType(loopData, ld.summary.connectorType)) {
                    this.callProgress(LogLevel_1.LogLevel.debug, options, APITasks_1.APITasks.skipConnectorType, [path, ld.summary.connectorType]);
                    return ListServer.GET_EMPTY_LIST_DATA(ld.summary.connectorType, ld.summary.dir);
                }
            }
            return ld;
        })
            .then(async (ld) => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            if (ld.entries.length > 0 && options.fnDirFilter) {
                await ListServer.dirFilterEntries(ld, options);
            }
            return ld;
        })
            .then(ld => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            if (ld.entries.length > 0 && options.recursive) {
                if (maxRecursiveDepth !== undefined && depth >= maxRecursiveDepth) {
                    this.callProgress(LogLevel_1.LogLevel.debug, options, APITasks_1.APITasks.skipDir, [path, maxRecursiveDepth]);
                    if (loopData.note === "") {
                        loopData.note = this.com.taskSupplier.get(APITasks_1.APITasks.skipDirNote, [maxRecursiveDepth]).getMessage();
                    }
                    return ld;
                }
                else {
                    const nEnd = ld.entries.length;
                    for (let i = 0; i < nEnd; i++) {
                        if (i % 50 === 0)
                            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                        if (ld.entries[i].type === "directory") {
                            if (isRootDir) {
                                if (!options.readInternalConnectors && ld.entries[i].src.indexOf("_") === 0) {
                                    this.callProgress(LogLevel_1.LogLevel.debug, options, APITasks_1.APITasks.skipInternalConnector, [ld.entries[i].path]);
                                }
                                else if (!ListServer.isValidConnectorType(loopData, ld.entries[i].connectorType)) {
                                    this.callProgress(LogLevel_1.LogLevel.debug, options, APITasks_1.APITasks.skipConnectorType, [ld.entries[i].path, ld.entries[i].connectorType]);
                                }
                                else {
                                    subDirsToRead.push(ld.entries[i].src);
                                }
                            }
                            else {
                                subDirsToRead.push(ld.entries[i].src);
                            }
                        }
                        else
                            break;
                    }
                    return ld;
                }
            }
            else
                return ld;
        })
            .then(async (ld) => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            if (ld.entries.length > 0 && options.fnFileFilter) {
                await ListServer.fileFilterEntries(ld, options);
            }
            return ld;
        })
            .then(async (ld) => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            ListServer.updateClientSummary(ld, options);
            if (options.dropEntries)
                ld.entries = [];
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            if (subDirsToRead.length > 0) {
                await this.getSubdirectories(path, baseDir, subDirsToRead, ld, options, progressSize, progressStart, depth, loopData);
                if (depth === 0) {
                    if (loopData.note === "") {
                        loopData.note = "complete";
                    }
                }
                return ld;
            }
            else {
                return ld;
            }
        })
            .then(ld => {
            ld.summary.clientInfo.note = loopData.note;
            ld.summary.clientInfo.maxDepth = loopData.maxDepth;
            if (depth === 0) {
                this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.readListServer, [path], 100, 100);
                this.taskController.resetSubTask();
            }
            return ld;
        });
    }
    addEntries(paths, options) {
        if (options.fnProgress !== undefined || options._fnQueueProgress !== undefined) {
            options._taskProgress = new TaskProgress_1.TaskProgress();
            options._taskProgress.currentTask = this.com.taskSupplier.get(APITasks_1.APITasks.addEntries, [paths.length]);
        }
        const data = {
            entries: [],
            length: paths.length,
            lists: [],
            paths,
            percentFactor: (paths.length === 0) ? 1 : 50 / paths.length,
            pos: 0,
            requiredConnectors: {},
            requiredLists: {},
            requiredListsCount: 0,
            type: "paths"
        };
        const self = this;
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                self.addNextEntry(data, options, {}, resolve, reject);
            }, 0);
        });
    }
    addEntryObjects(entries, options, addOptions = {}) {
        if (options.fnProgress !== undefined || options._fnQueueProgress !== undefined) {
            options._taskProgress = new TaskProgress_1.TaskProgress();
            options._taskProgress.currentTask = this.com.taskSupplier.get(APITasks_1.APITasks.addEntries, [entries.length]);
        }
        if (addOptions.basePath && addOptions.basePath.length > 0) {
            addOptions.basePath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(addOptions.basePath);
        }
        const data = {
            entries,
            length: entries.length,
            lists: [],
            paths: [],
            percentFactor: (entries.length === 0) ? 1 : 50 / entries.length,
            pos: 0,
            requiredConnectors: {},
            requiredLists: {},
            requiredListsCount: 0,
            type: "entries"
        };
        const self = this;
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                self.addNextEntry(data, options, addOptions, resolve, reject);
            }, 0);
        });
    }
    directoryContains(path, files, directories, options = {}) {
        const self = this;
        const find = (names, ld, type) => {
            for (const nam of names) {
                let found = false;
                for (const entry of ld.entries) {
                    if (entry.src === nam && type === entry.type) {
                        found = true;
                        break;
                    }
                }
                if (!found)
                    return false;
            }
            return true;
        };
        return new Promise((resolve) => {
            self.read(path, options)
                .then((ld) => {
                if (ld.entries.length === 0) {
                    return resolve(false);
                }
                if (ld.entries.length < (files.length + directories.length)) {
                    return false;
                }
                if (!find(files, ld, "file")) {
                    return resolve(false);
                }
                if (!find(directories, ld, "directory")) {
                    return resolve(false);
                }
                resolve(true);
            })
                .catch(() => {
                resolve(false);
            });
        });
    }
    initListData(ld, options) {
        const dir = ld.summary.dir;
        if (options.dropEntries) {
            ld.entries.forEach((entry) => {
                entry.path = dir + entry.src;
                entry.size = parseInt(entry.size, 10);
                entry.importStatus = parseInt(entry.importstatus, 10);
                delete entry.importstatus;
            });
        }
        else {
            ld.entries.forEach((entry) => {
                entry.path = dir + entry.src;
                entry._listData = ld;
                entry.lastModified = entry.lastmodified;
                delete entry.lastmodified;
                entry.importStatus = entry.importstatus;
                delete entry.importstatus;
                for (const o of Object.keys(EntryNumberDefaults)) {
                    if (entry[o] === undefined) {
                        entry[o] = EntryNumberDefaults[o];
                    }
                    else {
                        entry[o] = parseInt(entry[o], 10);
                    }
                }
            });
        }
    }
    callProgress(level, options, apiTaskDef, content, pos = 0, length = 0) {
        this.taskController.onStepProgress(level, options, apiTaskDef, content, pos, length);
    }
    getEntryInfo(path, options) {
        const q = new URLSearchParams("type=info");
        q.set("renderer", "noredirect");
        q.set("source", path);
        q.set("tpl", "info.json");
        const url = this.client.getServerBaseQueryPath() + q;
        return this.com.getJSON(url, { def: APIErrors_1.APIErrors.addEntry, content: [path] }, undefined, options)
            .then(response => {
            const entry = response;
            const dir = FSIServerClientUtils_1.FSIServerClientUtils.GET_PARENT_PATH(entry.src);
            entry.path = entry.src;
            entry.src = entry.src.substring(dir.length);
            if (entry.size === undefined) {
                entry.size = 0;
                entry.type = "directory";
            }
            else {
                entry.type = "file";
            }
            return entry;
        })
            .catch(err => {
            throw err;
        });
    }
    getEntryFromPath(data, options) {
        return this.getEntryInfo(data.paths[data.pos], options);
    }
    getConnectorTypeMap(items = [], options) {
        return new Promise((resolve) => {
            const listOptions = {
                abortController: options.abortController,
                readInternalConnectors: true,
                recursive: false,
            };
            if (items.length > 0) {
                listOptions.items = items;
            }
            const map = {};
            this.read("", listOptions)
                .then(list => {
                for (const entry of list.entries) {
                    if (entry.connectorType !== undefined) {
                        map[entry.src] = entry.connectorType;
                    }
                }
                return resolve(map);
            });
        });
    }
    doAddNextEntry(data, options, addOptions) {
        return new Promise(async (resolve, reject) => {
            let entry = null;
            try {
                if (data.type === "entries") {
                    const map = data.entries[data.pos];
                    if (!map || !map.src) {
                        return reject(new Error("Invalid entry"));
                    }
                    if (map.src.indexOf("/") !== -1) {
                        map.path = decodeURIComponent(map.src);
                        const fileAndPath = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(map.path);
                        map.src = fileAndPath.dir;
                    }
                    else {
                        if (map.fullsrc === undefined && addOptions && addOptions.basePath !== undefined) {
                            map.path = map.fullsrc = addOptions.basePath + map.src;
                        }
                        else {
                            map.path = decodeURIComponent(map.fullsrc);
                        }
                    }
                    if (!map.path) {
                        return reject(new Error("Invalid entry"));
                    }
                    if (!addOptions || !addOptions.progressMod || data.pos % addOptions.progressMod === 0) {
                        this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.addingEntry, [data.pos + 1,
                            data.length, map.path], data.pos * data.percentFactor, 100);
                    }
                    entry = data.entries[data.pos];
                }
                else {
                    this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.addingEntry, [data.pos + 1,
                        data.length, data.paths[data.pos]], data.pos * data.percentFactor, 100);
                    entry = await this.getEntryFromPath(data, options);
                }
            }
            catch (err) {
                if (!options.continueOnError) {
                    return reject(err);
                }
                else {
                    if (options._fnQueueError !== undefined) {
                        await options._fnQueueError.fn.call(options._fnQueueError.ctx, err);
                    }
                    this.taskController.error(err, "ERROR: ");
                }
            }
            if (entry !== null) {
                let parentPath;
                if (!addOptions || !addOptions.progressMod || data.pos % addOptions.progressMod === 0) {
                    this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.addingEntry, [(data.pos + 1), data.length, entry.path], (data.pos + 1) * data.percentFactor, 100);
                }
                if (entry.type === "file") {
                    const pf = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(entry.path);
                    parentPath = pf.path;
                }
                else {
                    parentPath = FSIServerClientUtils_1.FSIServerClientUtils.GET_PARENT_PATH(entry.path);
                }
                const connectorName = FSIServerClientUtils_1.FSIServerClientUtils.GET_BASE_PATH(entry.path);
                if (!data.requiredConnectors[connectorName]) {
                    data.requiredConnectors[connectorName] = connectorName;
                }
                if (data.requiredLists[parentPath] === undefined) {
                    data.requiredListsCount++;
                    data.requiredLists[parentPath] = {
                        directoryCount: 0,
                        entries: [],
                        entrySources: [],
                        imageCount: 0
                    };
                }
                if (entry.type === "file") {
                    data.requiredLists[parentPath].imageCount++;
                }
                else {
                    data.requiredLists[parentPath].directoryCount++;
                }
                data.requiredLists[parentPath].entries.push(entry);
                data.requiredLists[parentPath].entrySources.push(entry.src);
            }
            return resolve();
        });
    }
    addNextEntry(data, options, addOptions, fnResolve, fnReject) {
        const self = this;
        try {
            if (data.pos >= data.length) {
                data.pos = 0;
                data.length = data.requiredListsCount;
                const items = [];
                for (const key of Object.keys(data.requiredConnectors)) {
                    items.push(key);
                }
                this.getConnectorTypeMap(items, options)
                    .then((map) => {
                    data.requiredConnectors = map;
                    this.listNextEntry(data, options, fnResolve, fnReject);
                })
                    .catch((err) => {
                    return fnReject(err);
                });
            }
            else {
                this.doAddNextEntry(data, options, addOptions)
                    .then(() => {
                    if (data.pos % 100 === 0) {
                        data.pos++;
                        setTimeout(() => {
                            self.addNextEntry(data, options, addOptions, fnResolve, fnReject);
                        }, 0);
                    }
                    else {
                        data.pos++;
                        this.addNextEntry(data, options, addOptions, fnResolve, fnReject);
                    }
                })
                    .catch(err => {
                    return fnReject(err);
                });
            }
        }
        catch (err) {
            return fnReject(err);
        }
    }
    listNextEntry(data, options, fnResolve, fnReject) {
        data.percentFactor = (data.requiredListsCount === 0) ? 1 : 50 / data.requiredListsCount;
        let n = 0;
        if (data.requiredListsCount === 0) {
            return fnResolve(data.lists);
        }
        else {
            for (const path of Object.keys(data.requiredLists)) {
                try {
                    this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.addingEntryList, [(n + 1), data.requiredListsCount, path], 50 + n * data.percentFactor, 100);
                    const curListOptions = Object.assign({}, options);
                    curListOptions.limit = "0,1";
                    curListOptions.recursive = false;
                    curListOptions.readInternalConnectors = true;
                    const connector = FSIServerClientUtils_1.FSIServerClientUtils.GET_BASE_PATH(path);
                    if (data.requiredConnectors[connector] === undefined) {
                        return fnReject(new Error("Unknown connector \"" + connector + "\""));
                    }
                    const ld = ListServer.GET_EMPTY_LIST_DATA();
                    ld.summary.connectorType = data.requiredConnectors[connector];
                    ld.summary.dir = ld.summary._baseDir = path;
                    ld.summary.imageCount = data.requiredLists[path].imageCount;
                    ld.summary.directoryCount = data.requiredLists[path].directoryCount;
                    ld.entries = data.requiredLists[path].entries;
                    ld.summary.entryCount = ld.entries.length;
                    data.lists.push(ld);
                    this.initListData(ld, options);
                    ListServer.updateClientSummary(ld, options);
                }
                catch (err) {
                    if (!options.continueOnError) {
                        return fnReject(err);
                    }
                    else {
                        if (options._fnQueueError !== undefined) {
                            options._fnQueueError.fn.call(options._fnQueueError.ctx, err);
                        }
                        this.taskController.error(err, "ERROR: ");
                    }
                }
                n++;
                this.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.addingEntryList, [n, data.requiredListsCount, path], 50 + n * data.percentFactor, 100);
                if (n === data.requiredListsCount) {
                    this.taskController.resetSubTask();
                    return fnResolve(data.lists);
                }
            }
        }
    }
}
exports.ListServer = ListServer;
_a = ListServer;
ListServer.dirFilterEntries = async (ld, options) => {
    if (options.fnDirFilter) {
        const collectEntries = !options.dropEntries;
        for (let i = 0; i < ld.entries.length; i++) {
            const theEntry = ld.entries[i];
            if (theEntry.type !== "directory")
                break;
            if (!await options.fnDirFilter(ld, theEntry)) {
                ld.summary.directoryCount--;
                ld.summary.entryCount--;
                if (collectEntries) {
                    ld.entries.splice(i, 1);
                    i--;
                }
            }
        }
    }
};
ListServer.fileFilterEntries = async (ld, options) => {
    if (options.fnFileFilter) {
        const collectEntries = !options.dropEntries;
        for (let i = 0; i < ld.entries.length; i++) {
            const theEntry = ld.entries[i];
            if (!await options.fnFileFilter(ld, theEntry)) {
                if (theEntry.type === "file")
                    ld.summary.imageCount--;
                else
                    ld.summary.directoryCount--;
                ld.summary.entryCount--;
                if (collectEntries) {
                    ld.entries.splice(i, 1);
                    i--;
                }
            }
        }
    }
};
